import { Calendar } from '@powerportalspro/react-calendar';
import { ACCOUNT_ID } from '../demos/DetailPageRecords';

// Schmeler and Sons' appointments, tasks and phone calls.
const account = { tableName: 'account', id: ACCOUNT_ID };

export function CalendarWeekLayoutSample() {
  return (
    <Calendar
      regarding={account}
      defaultLayout="week"
      defaultTables={['appointment', 'task', 'phonecall']}
      height="640px"
    />
  );
}
